import { render, staticRenderFns } from "./LinkLogin.vue?vue&type=template&id=e8b07bf2&"
import script from "./LinkLogin.vue?vue&type=script&lang=js&"
export * from "./LinkLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports